<script lang="ts" setup>
const {
  onHandleConfirm,
  offHandleConfirm,
  onHandleForceCloseAllTheDialog,
  offHandleForceCloseAllTheDialog,
} = useDialogInit()

const show = ref(false)
const pending = ref(false)
const dialogConfirmOption = ref<IEventBusDialogConfirm | null>(null)

onBeforeMount(() => {
  onHandleConfirm(handleShow.bind(this))
  onHandleForceCloseAllTheDialog(handleForceClose.bind(this))
})

onBeforeUnmount(() => {
  offHandleConfirm(handleShow.bind(this))
  offHandleForceCloseAllTheDialog(handleForceClose.bind(this))
})

const handleShow = (option: IEventBusDialogConfirm) => {
  dialogConfirmOption.value = {
    ...option,
    bodyScrollLock:
      option.bodyScrollLock === undefined ? true : option.bodyScrollLock,
  }
  show.value = true
}

const handleClickConfirm = async () => {
  try {
    pending.value = true
    await dialogConfirmOption.value?.onConfirm()
    show.value = false
  } finally {
    pending.value = false
  }
}

const handleClickCancel = () => {
  show.value = false
  dialogConfirmOption.value?.onCancel()
}

const handleForceClose = () => {
  show.value = false
}
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <BaseDialog
    v-model="show"
    footer-fixed
    persistent
    :body-scroll-lock="dialogConfirmOption?.bodyScrollLock"
  >
    <template #content>
      <div class="TheDialogConfirm__content">
        <div class="TheDialogConfirm__contentInner">
          <h3
            v-if="dialogConfirmOption?.title"
            class="TheDialogConfirm__contentTitle"
            v-html="dialogConfirmOption.title"
          />
          <p
            v-if="dialogConfirmOption?.message"
            class="TheDialogConfirm__contentMessage"
            v-html="dialogConfirmOption.message"
          />
        </div>
      </div>
    </template>
    <template #footer>
      <div class="TheDialogConfirm__footer">
        <BaseButtonRectangleTertiary
          class="TheDialogConfirm__footerCancel"
          :title="dialogConfirmOption?.buttonText.cancel"
          size="large"
          blocked
          @click="handleClickCancel"
        />
        <BaseButtonRectanglePrimary
          :title="dialogConfirmOption?.buttonText.confirm"
          :pending="pending"
          size="large"
          blocked
          @click="handleClickConfirm"
        />
      </div>
    </template>
  </BaseDialog>
</template>

<style lang="scss" scoped>
.TheDialogConfirm {
  &__content {
    @apply px-[16px] pt-[24px] pb-[16px];

    &Inner {
      @apply text-center;
    }

    &Title {
      @apply subtitle3_bold_medium gray-333--text;
      @apply whitespace-pre-wrap;
      @apply mb-[10px];
    }

    &Message {
      @apply body1_regular_medium gray-666--text;
      @apply whitespace-pre-line;
    }
  }

  &__footer {
    @apply flex;

    &Cancel {
      @apply mr-[8px];
    }
  }
}
</style>
